import type { InputHTMLAttributes } from 'react';
import { cx } from '../lib/cx';
import { Field, borderClass, controlClass } from './Field';

export interface NumberInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id' | 'type' | 'onChange' | 'value'> {
  id: string;
  label?: string;
  hint?: string;
  error?: string | undefined;
  value: number | '';
  onValueChange: (value: number | '') => void;
  suffix?: string;
}

/**
 * Brojčano polje za teretanu: `inputMode="decimal"` da telefon odmah otvori brojčanu
 * tipkovnicu, prazan string kao legitimno stanje (set koji još nije unesen).
 */
export function NumberInput({
  id,
  label,
  hint,
  error,
  value,
  onValueChange,
  suffix,
  className,
  required,
  ...rest
}: NumberInputProps) {
  return (
    <Field id={id} label={label} hint={hint} error={error} required={required}>
      <div className="relative">
        <input
          id={id}
          type="number"
          inputMode="decimal"
          value={value === '' ? '' : String(value)}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined}
          onChange={(e) => {
            const raw = e.target.value;
            if (raw === '') return onValueChange('');
            const n = Number(raw);
            onValueChange(Number.isNaN(n) ? '' : n);
          }}
          className={cx(controlClass, borderClass(!!error), suffix && 'pr-12', className)}
          {...rest}
        />
        {suffix && (
          <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-[13px] text-ink-muted">
            {suffix}
          </span>
        )}
      </div>
    </Field>
  );
}
